import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isLoggedIn: false,
    userDetails: {},
    redirectUrl: null,
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        login: (state, action) => {
            state.userDetails = action.payload.userDetails
            state.isLoggedIn = true
        },
        logout: (state, action) => {
            state.isLoggedIn = false
            state.userDetails = {}
        },
        updateDetails: (state, action) => {
            state.userDetails = {
                ...state.userDetails,
                ...action.payload.userDetails,
            }
        },
        setRedirectUrl: (state, action) => {
            state.redirectUrl = action.payload
        },
        resetRedirectUrl: state => {
            state.redirectUrl = null
        },
    },
})

const {
    login,
    logout,
    updateDetails,
    setRedirectUrl,
    resetRedirectUrl,
} = userSlice.actions

export const userActions = {
    login,
    logout,
    updateDetails,
    setRedirectUrl,
    resetRedirectUrl,
}

export const userSelectors = {
    isLoggedIn: state => state.user.isLoggedIn,
    userDetails: state => state.user.userDetails,
    userType: state => state.user.userDetails.userType,
    redirectUrl: state => state.user.redirectUrl,
}

export default userSlice.reducer
